export default "__VITE_ASSET__BAHPZMuF__"